module.exports = __webpack_public_path__ + "static/media/feishu_robot.56492c6d.png";